/*
 *  I01TEMPATTI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-02 12:51:11 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I01TEMPATT_SECTION_0_TITLE: '',
  I01TEMPATT_tube_uuid: 'Diamètre Intérieur:',
  I01TEMPATT_tube_uuid_mail: 'Diamètre:',
  I01TEMPATT_in_longConduit: 'Longueur du conduit',
  I01TEMPATT_in_longConduit_mail: 'Longuer de la conduite',
  I01TEMPATT_in_debitPuisage: 'Débit du point de puisage',
  I01TEMPATT_SECTION_1_TITLE: '',
  I01TEMPATT_res_volEauFroid: "Volume d'eau froide",
  I01TEMPATT_res_tpsAttenteEauChaude: 'Temps attente eau chaude'
}
